import DefaulticonMutations from './mutations-types'

export default {
  [DefaulticonMutations.SET_DEFAULTICONS](state, defaulticons) {
    state.defaulticons = [...defaulticons]
  },

  [DefaulticonMutations.SET_SELECTED_DEFAULTICON](state, defaulticon) {
    state.selectedDefaulticon = defaulticon

    state.fields.forEach((field) => {
      field.value = null

      if (defaulticon) {
        field.value = defaulticon[field.name]
      }
    })
  }
}
